(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filmrol"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filmrol-kiezer')) {
    customElements.define(
      'filmrol-kiezer',
      class extends HTMLElement {
        connectedCallback() {
          this.films = Array.from(this.querySelectorAll('[data-filmrol-film]'));
          this.frames = Array.from(this.querySelectorAll('[data-filmrol-kies]'));
          this.frames.forEach((frame, k) => {
            frame.addEventListener('click', () => this.choose(k));
          });
          this.querySelectorAll('[data-filmrol-play]').forEach((btn) => {
            btn.addEventListener('click', (event) => {
              const film = event.target.closest('[data-filmrol-film]');
              const overlay = film.querySelector('[data-filmrol-overlay]');
              const video = film.querySelector('video');
              if (overlay) overlay.classList.add('is-verborgen');
              if (video) video.play();
            });
          });
        }

        choose(k) {
          this.films.forEach((film, i) => {
            film.classList.toggle('is-actief', i === k);
            const video = film.querySelector('video');
            const overlay = film.querySelector('[data-filmrol-overlay]');
            if (video && i !== k) video.pause();
            if (overlay && i !== k) overlay.classList.remove('is-verborgen');
          });
          this.frames.forEach((frame, i) => {
            frame.classList.toggle('is-actief', i === k);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-plank"] && !Shopify.designMode) return;
  try {
    
  // Sitewide: product-card colour photos are lazy, so hovering a swatch showed
  // a blank card until the photo downloaded. Start loading a card's colour
  // photos as soon as the pointer enters the card.
  document.addEventListener(
    'pointerover',
    (event) => {
      const card = event.target instanceof Element && event.target.closest('product-card');
      if (!card || card.dataset.swatchPreload) return;
      card.dataset.swatchPreload = 'true';
      card.querySelectorAll('[data-option-media-id]').forEach((input) => {
        const id = input.getAttribute('data-option-media-id');
        if (!id) return;
        const img = card.querySelector(`slideshow-slide[slide-id="${id}"] img[loading="lazy"]`);
        if (img) img.loading = 'eager';
      });
    },
    { passive: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fotoboek"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotoboek-boek')) {
    customElements.define(
      'fotoboek-boek',
      class extends HTMLElement {
        connectedCallback() {
          this.spreads = Array.from(this.querySelectorAll('[data-fotoboek-spread]'));
          this.counter = this.querySelector('[data-fotoboek-index]');
          this.index = 0;
          const prev = this.querySelector('[data-fotoboek-prev]');
          const next = this.querySelector('[data-fotoboek-next]');
          if (prev) prev.addEventListener('click', () => this.show(this.index - 1));
          if (next) next.addEventListener('click', () => this.show(this.index + 1));
          const warm = () => {
            this.querySelectorAll('.fotoboek__foto[src]').forEach((img) => {
              new Image().src = img.currentSrc || img.src;
            });
          };
          if ('requestIdleCallback' in window) {
            requestIdleCallback(warm);
          } else {
            setTimeout(warm, 1200);
          }
        }

        show(n) {
          const total = this.spreads.length;
          if (!total) return;
          this.index = ((n % total) + total) % total;
          this.spreads.forEach((spread, k) => {
            spread.classList.toggle('is-open', k === this.index);
          });
          if (this.counter) this.counter.textContent = this.index + 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-hoek"] && !Shopify.designMode) return;
  try {
    
  class NewsletterHoek extends HTMLElement {
    static STORAGE_KEY = 'solune:newsletter-hoek';

    connectedCallback() {
      this.card = this.querySelector('.newsletter-hoek__card');
      if (!this.card) return;

      this.bindDismiss();

      if (this.hasAttribute('data-design-mode')) {
        this.bindDesignMode();
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const posted = params.get('customer_posted') === 'true';
      const fromPopup = params.get('nb') === 'ok';

      if (posted || fromPopup) {
        this.remember(365);
        if (fromPopup) {
          const success = this.card.querySelector('.newsletter-hoek__success');
          if (success) success.hidden = false;
          this.card.setAttribute('data-success', '');
          this.show();
        }
        return;
      }

      if (this.card.querySelector('.newsletter-hoek__message--error')) {
        this.show();
        return;
      }

      if (this.isSnoozed()) return;

      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          this.showWhenClear();
        }
      });
      observer.observe(this);
    }

    showWhenClear() {
      const banner = document.getElementById('shopify-pc__banner');
      if (banner && banner.offsetParent !== null) {
        setTimeout(() => this.showWhenClear(), 1500);
        return;
      }
      this.show();
    }

    show() {
      this.card.hidden = false;
      this.card.setAttribute('data-open', '');
    }

    hide() {
      this.card.hidden = true;
      this.card.removeAttribute('data-open');
    }

    bindDismiss() {
      const dismiss = () => {
        this.hide();
        if (!this.hasAttribute('data-design-mode')) this.remember(30);
      };
      this.card.querySelector('.newsletter-hoek__close')?.addEventListener('click', dismiss);
      this.card.querySelector('.newsletter-hoek__decline')?.addEventListener('click', dismiss);
    }

    bindDesignMode() {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) this.show();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) this.hide();
      });
    }

    remember(days) {
      try {
        const until = Date.now() + days * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(NewsletterHoek.STORAGE_KEY, JSON.stringify({ until }));
      } catch (error) {
        /* storage unavailable: show again next visit */
      }
    }

    isSnoozed() {
      try {
        const raw = window.localStorage.getItem(NewsletterHoek.STORAGE_KEY);
        if (!raw) return false;
        return Date.now() < JSON.parse(raw).until;
      } catch (error) {
        return false;
      }
    }
  }

  if (!customElements.get('newsletter-hoek')) {
    customElements.define('newsletter-hoek', NewsletterHoek);
  }

  } catch(e) { console.error(e); }
})();
})();
